import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function DataVisualizationWorkshop() {

    const images = [
        "1.jpg",
        "2.jpg",
        "4.jpg",
        "5.jpg",
        "6.jpg"
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">

                                    <h2 className="pb-2">
                                        Data Visualization using Tableau/Power BI Workshop
                                    </h2>

                                    <p>
                                        The IT Department conducted a <strong>Data Visualization using Tableau/Power BI Workshop</strong> 
                                        for <strong>2nd-year IT students</strong> from <strong>27th October to 1st November, 2025</strong>.
                                        <br /><br />
                                        This workshop aimed to equip students with hands-on skills in creating meaningful 
                                        and interactive data visualizations. Students learned how to analyze, interpret, 
                                        and present data using modern BI tools, enhancing their ability to work with 
                                        dashboards and real-time insights.
                                        <br /><br />
                                        The sessions covered:
                                        <br />
                                        • Basics of data visualization  
                                        <br />
                                        • Designing charts and dashboards  
                                        <br />
                                        • Working with datasets in Tableau and Power BI  
                                        <br />
                                        • Building interactive and dynamic reports  
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/tableau-powerbi-workshop/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/tableau-powerbi-workshop/${img}`}
                                                            loading="lazy"
                                                            alt={`Data Visualization Workshop Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1 sixteen-nine"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default DataVisualizationWorkshop;
